// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.txn-show {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  padding: 24px 32px 32px;
  background: #ffffff;
}

.txn-show__stack {
  display: flex;
  flex-direction: column;
  min-width: 0;
  width: 100%;
}

.txn-show__top {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f1f5f9;
  flex-shrink: 0;
}

.txn-show__crumb {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  line-height: 16px;
  text-transform: uppercase;
  color: #94a3b8;
}

.txn-show__crumb button {
  border: none;
  padding: 0;
  background: transparent;
  color: #64748b;
  font: inherit;
  cursor: pointer;
}

.txn-show__crumb button:hover {
  color: #0f172a;
}

.txn-show__crumb .is-current {
  color: #0f172a;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}

.txn-show__hero {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.txn-show__heading {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  min-width: 0;
}

.txn-show__title {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #0f172a;
  line-height: 1.2;
}

.txn-show__code {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-weight: 500;
  color: #475569;
}

.txn-show__id {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  color: #94a3b8;
}

.txn-show__status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 22px;
  padding: 0 10px;
  border-radius: 9999px;
  border: 1px solid #a7f3d0;
  background: #ecfdf5;
  color: #047857;
  font-size: 12px;
  font-weight: 600;
}

.txn-show__status.is-reversed {
  border-color: #fecaca;
  background: #fef2f2;
  color: #b91c1c;
}

.txn-show__status-dot {
  width: 6px;
  height: 6px;
  border-radius: 9999px;
  background: currentColor;
}

.txn-show__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.txn-show__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #334155;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
}

.txn-show__btn:hover {
  background: #f8fafc;
  color: #0f172a;
}

.txn-show__btn--danger {
  border-color: #fecaca;
  background: #fff1f2;
  color: #be123c;
}

.txn-show__btn--danger:hover {
  background: #ffe4e6;
  color: #9f1239;
}

[dir='rtl'] .txn-show__btn .lucide-arrow {
  transform: scaleX(-1);
}

.txn-show__body {
  padding: 20px 0 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #ffffff;
}

.txn-show__metrics {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.txn-show__metric {
  box-sizing: border-box;
  min-width: 0;
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #ffffff;
}

.txn-show__metric-label {
  margin: 0;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748b;
}

.txn-show__metric-value {
  margin: 6px 0 0;
  font-size: 18px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.txn-show__metric-value.is-amount {
  font-size: 24px;
  font-variant-numeric: tabular-nums;
}

.txn-show__metric-sub {
  margin: 4px 0 0;
  font-size: 12px;
  color: #64748b;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.txn-show__card {
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #ffffff;
  overflow: hidden;
}

.txn-show__card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 20px;
  border-bottom: 1px solid #f1f5f9;
}

.txn-show__card-title {
  margin: 0;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748b;
}

.txn-show__specs {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  padding: 16px 20px 20px;
}

.txn-show__spec-label {
  margin: 0;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #94a3b8;
}

.txn-show__spec-value {
  margin: 4px 0 0;
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.4;
  word-break: break-word;
}

.txn-show__spec-value.is-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}

.txn-show__spec-value.is-empty {
  color: #94a3b8;
  font-weight: 500;
  font-style: italic;
}

.txn-show__spec-label + .txn-show__spec-value + .txn-show__spec-label {
  margin-top: 14px;
}

.txn-show__flags {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}

.txn-show__flag {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  font-size: 12px;
  font-weight: 500;
  color: #334155;
}

.txn-show__flag-value {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #64748b;
  font-size: 11px;
  font-weight: 600;
}

.txn-show__flag-value.is-yes {
  border-color: #a7f3d0;
  background: #ecfdf5;
  color: #047857;
}

.txn-show__note {
  margin: 8px 0 0;
  min-height: 72px;
  padding: 12px;
  border: 1px solid #e0f2fe;
  border-radius: 8px;
  background: #f0f9ff;
  font-size: 13px;
  line-height: 1.5;
  color: #334155;
}

.txn-show__note.is-empty {
  color: #94a3b8;
  font-style: italic;
}

.txn-show__entries-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 20px;
  border-bottom: 1px solid #f1f5f9;
}

.txn-show__entries-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
}

.txn-show__entries-dot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  background: #0ea5e9;
}

.txn-show__entries-count {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  font-weight: 500;
  color: #94a3b8;
}

.txn-show__table-scroll {
  width: 100%;
  overflow-x: auto;
}

.txn-show__table {
  width: 100%;
  min-width: 760px;
  border-collapse: collapse;
  font-size: 12px;
}

.txn-show__table th,
.txn-show__table td {
  padding: 10px 16px;
  text-align: start;
  vertical-align: middle;
  border-bottom: 1px solid #f1f5f9;
  white-space: nowrap;
}

.txn-show__table th {
  background: #f8fafc;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #64748b;
}

.txn-show__table th.is-end,
.txn-show__table td.is-end {
  text-align: end;
}

.txn-show__table tbody tr:hover td {
  background: #f8fafc;
}

.txn-show__table tfoot td {
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  border-bottom: 0;
  font-weight: 700;
  color: #0f172a;
}

.txn-show__mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-variant-numeric: tabular-nums;
  color: #64748b;
}

.txn-show__strong {
  font-weight: 600;
  color: #0f172a;
}

.txn-show__dash {
  color: #cbd5e1;
}

.txn-show__chip {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  font-size: 11px;
  font-weight: 600;
  color: #475569;
}

.txn-show__chip.is-debit {
  border-color: #bae6fd;
  background: #f0f9ff;
  color: #0369a1;
}

.txn-show__chip.is-credit {
  border-color: #99f6e4;
  background: #f0fdfa;
  color: #0f766e;
}

.txn-show__balance {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 20px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
  font-size: 12px;
  color: #64748b;
}

.txn-show__balance strong {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  color: #0f172a;
}

@media (max-width: 1100px) {
  .txn-show__metrics,
  .txn-show__specs {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 720px) {
  .txn-show {
    padding: 16px;
  }

  .txn-show__hero,
  .txn-show__metrics,
  .txn-show__specs {
    display: flex;
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/accounting/ShowTransaction/style.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,6EAA6E;AAC/E;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6EAA6E;EAC7E,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6EAA6E;EAC7E,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,6EAA6E;AAC/E;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,6EAA6E;EAC7E,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6EAA6E;EAC7E,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,6EAA6E;EAC7E,cAAc;AAChB;;AAEA;EACE;;IAEE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;;IAGE,aAAa;IACb,sBAAsB;EACxB;AACF","sourcesContent":[".txn-show {\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  padding: 24px 32px 32px;\n  background: #ffffff;\n}\n\n.txn-show__stack {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  width: 100%;\n}\n\n.txn-show__top {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #f1f5f9;\n  flex-shrink: 0;\n}\n\n.txn-show__crumb {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  line-height: 16px;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.txn-show__crumb button {\n  border: none;\n  padding: 0;\n  background: transparent;\n  color: #64748b;\n  font: inherit;\n  cursor: pointer;\n}\n\n.txn-show__crumb button:hover {\n  color: #0f172a;\n}\n\n.txn-show__crumb .is-current {\n  color: #0f172a;\n  font-weight: 600;\n  text-transform: none;\n  letter-spacing: 0;\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n}\n\n.txn-show__hero {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.txn-show__heading {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  min-width: 0;\n}\n\n.txn-show__title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #0f172a;\n  line-height: 1.2;\n}\n\n.txn-show__code {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-weight: 500;\n  color: #475569;\n}\n\n.txn-show__id {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 12px;\n  color: #94a3b8;\n}\n\n.txn-show__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 22px;\n  padding: 0 10px;\n  border-radius: 9999px;\n  border: 1px solid #a7f3d0;\n  background: #ecfdf5;\n  color: #047857;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.txn-show__status.is-reversed {\n  border-color: #fecaca;\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.txn-show__status-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 9999px;\n  background: currentColor;\n}\n\n.txn-show__actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.txn-show__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 32px;\n  padding: 0 12px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  color: #334155;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.txn-show__btn:hover {\n  background: #f8fafc;\n  color: #0f172a;\n}\n\n.txn-show__btn--danger {\n  border-color: #fecaca;\n  background: #fff1f2;\n  color: #be123c;\n}\n\n.txn-show__btn--danger:hover {\n  background: #ffe4e6;\n  color: #9f1239;\n}\n\n[dir='rtl'] .txn-show__btn .lucide-arrow {\n  transform: scaleX(-1);\n}\n\n.txn-show__body {\n  padding: 20px 0 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  background: #ffffff;\n}\n\n.txn-show__metrics {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.txn-show__metric {\n  box-sizing: border-box;\n  min-width: 0;\n  padding: 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #ffffff;\n}\n\n.txn-show__metric-label {\n  margin: 0;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.txn-show__metric-value {\n  margin: 6px 0 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: #0f172a;\n  line-height: 1.25;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.txn-show__metric-value.is-amount {\n  font-size: 24px;\n  font-variant-numeric: tabular-nums;\n}\n\n.txn-show__metric-sub {\n  margin: 4px 0 0;\n  font-size: 12px;\n  color: #64748b;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.txn-show__card {\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #ffffff;\n  overflow: hidden;\n}\n\n.txn-show__card-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 20px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.txn-show__card-title {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.txn-show__specs {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 20px;\n  padding: 16px 20px 20px;\n}\n\n.txn-show__spec-label {\n  margin: 0;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #94a3b8;\n}\n\n.txn-show__spec-value {\n  margin: 4px 0 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #1e293b;\n  line-height: 1.4;\n  word-break: break-word;\n}\n\n.txn-show__spec-value.is-mono {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n}\n\n.txn-show__spec-value.is-empty {\n  color: #94a3b8;\n  font-weight: 500;\n  font-style: italic;\n}\n\n.txn-show__spec-label + .txn-show__spec-value + .txn-show__spec-label {\n  margin-top: 14px;\n}\n\n.txn-show__flags {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.txn-show__flag {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 8px 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #f8fafc;\n  font-size: 12px;\n  font-weight: 500;\n  color: #334155;\n}\n\n.txn-show__flag-value {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 8px;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  color: #64748b;\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.txn-show__flag-value.is-yes {\n  border-color: #a7f3d0;\n  background: #ecfdf5;\n  color: #047857;\n}\n\n.txn-show__note {\n  margin: 8px 0 0;\n  min-height: 72px;\n  padding: 12px;\n  border: 1px solid #e0f2fe;\n  border-radius: 8px;\n  background: #f0f9ff;\n  font-size: 13px;\n  line-height: 1.5;\n  color: #334155;\n}\n\n.txn-show__note.is-empty {\n  color: #94a3b8;\n  font-style: italic;\n}\n\n.txn-show__entries-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 20px;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.txn-show__entries-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.txn-show__entries-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 9999px;\n  background: #0ea5e9;\n}\n\n.txn-show__entries-count {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-size: 12px;\n  font-weight: 500;\n  color: #94a3b8;\n}\n\n.txn-show__table-scroll {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.txn-show__table {\n  width: 100%;\n  min-width: 760px;\n  border-collapse: collapse;\n  font-size: 12px;\n}\n\n.txn-show__table th,\n.txn-show__table td {\n  padding: 10px 16px;\n  text-align: start;\n  vertical-align: middle;\n  border-bottom: 1px solid #f1f5f9;\n  white-space: nowrap;\n}\n\n.txn-show__table th {\n  background: #f8fafc;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.txn-show__table th.is-end,\n.txn-show__table td.is-end {\n  text-align: end;\n}\n\n.txn-show__table tbody tr:hover td {\n  background: #f8fafc;\n}\n\n.txn-show__table tfoot td {\n  background: #f8fafc;\n  border-top: 1px solid #e2e8f0;\n  border-bottom: 0;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.txn-show__mono {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  font-variant-numeric: tabular-nums;\n  color: #64748b;\n}\n\n.txn-show__strong {\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.txn-show__dash {\n  color: #cbd5e1;\n}\n\n.txn-show__chip {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 8px;\n  border-radius: 6px;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n  font-size: 11px;\n  font-weight: 600;\n  color: #475569;\n}\n\n.txn-show__chip.is-debit {\n  border-color: #bae6fd;\n  background: #f0f9ff;\n  color: #0369a1;\n}\n\n.txn-show__chip.is-credit {\n  border-color: #99f6e4;\n  background: #f0fdfa;\n  color: #0f766e;\n}\n\n.txn-show__balance {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 20px;\n  border-top: 1px solid #e2e8f0;\n  background: #f8fafc;\n  font-size: 12px;\n  color: #64748b;\n}\n\n.txn-show__balance strong {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  color: #0f172a;\n}\n\n@media (max-width: 1100px) {\n  .txn-show__metrics,\n  .txn-show__specs {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (max-width: 720px) {\n  .txn-show {\n    padding: 16px;\n  }\n\n  .txn-show__hero,\n  .txn-show__metrics,\n  .txn-show__specs {\n    display: flex;\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
